var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityCloudIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5001L8 12.5001L12 8.50011M17 10.5001C17 14.9612 11.54 18.1938 9.6414 19.1831C9.4361 19.2901 9.3334 19.3436 9.191 19.3713C9.08 19.3929 8.92 19.3929 8.809 19.3713C8.6666 19.3436 8.5639 19.2901 8.3586 19.1831C6.45996 18.1938 1 14.9612 1 10.5001V6.71771C1 5.9182 1 5.51845 1.13076 5.17482C1.24627 4.87125 1.43398 4.60039 1.67766 4.38564C1.9535 4.14255 2.3278 4.00219 3.0764 3.72146L8.4382 1.71079C8.6461 1.63283 8.75 1.59385 8.857 1.57839C8.9518 1.56469 9.0482 1.56469 9.143 1.57839C9.25 1.59385 9.3539 1.63283 9.5618 1.71079L14.9236 3.72146C15.6722 4.00219 16.0465 4.14255 16.3223 4.38564C16.566 4.60039 16.7537 4.87125 16.8692 5.17482C17 5.51845 17 5.9182 17 6.71771V10.5001Z",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCloudIcon);
export default __webpack_public_path__ + "static/media/SecurityCloudIcon.3b4ce6c1a13d93b2ea6b328f9221fce8.svg";
export { ForwardRef as ReactComponent };